import axios from 'axios';

export default class Adapter {
    constructor(loader, urlOrObject) {
        this.loader = loader;
        this.url = urlOrObject.url;
    }

    async upload()
    {
        var me = this;
        try
        {
            var file = await me.loader.file;

            let data = new FormData();
            data.append('file', file);

            var defaultOptions = {
                headers: {
                    'content-type': 'multipart/form-data;',
                }
            };

            var response = await axios.post(me.url, data, defaultOptions);

            if(response.data.error == false) return {default: response.data.url}

            throw('could not upload this image')

        }
        catch (error)
        {
          console.log(error);
          throw('Upload failed');
        }
    }

    abort()
    {
      console.log('abort');
    }
}
